import {RegionCode} from "@casas-diamante/types"
import React, {createContext, useContext, useState, ReactNode} from "react"

const RegionContext = createContext({
   selectedRegion: RegionCode.ACA,
   setSelectedRegion: (region: RegionCode) => {
      // Default implementation does nothing
      console.warn("setSelectedRegion not implemented: ", region)
   },
})

export const RegionProvider = ({children}: {children: ReactNode}) => {
   const [selectedRegion, setSelectedRegion] = useState<RegionCode>(RegionCode.ACA)

   return (
      <RegionContext.Provider value={{selectedRegion, setSelectedRegion}}>
         {children}
      </RegionContext.Provider>
   )
}

export const useRegion = () => useContext(RegionContext)
